// Draft QR captions for every supported PDF locale; patient distribution requires review.
export const CONCEPT_PRINT_QR_LABELS = Object.freeze({
  "en": {
    "scanToOpenIn": "Scan to open in",
    "qrDescription": "This QR code opens the hospital's current published Journey in the selected app language. Check online for updates."
  },
  "fr": {
    "scanToOpenIn": "Scannez pour ouvrir en",
    "qrDescription": "Ce code QR ouvre le parcours de soins actuellement publié par cet hôpital dans la langue choisie. Vérifiez les mises à jour en ligne."
  },
  "es": {
    "scanToOpenIn": "Escanee para abrir en",
    "qrDescription": "Este código QR abre el recorrido asistencial publicado por el hospital en el idioma seleccionado. Consulte las actualizaciones en línea."
  },
  "ar": {
    "scanToOpenIn": "امسح الرمز لفتح الدليل باللغة",
    "qrDescription": "يفتح رمز الاستجابة السريعة هذا رحلة الرعاية المنشورة حاليًا لهذا المستشفى باللغة المحددة. تحقّق من التحديثات عبر الإنترنت."
  },
  "pl": {
    "scanToOpenIn": "Zeskanuj, aby otworzyć w języku",
    "qrDescription": "Ten kod QR otwiera aktualnie opublikowany przewodnik szpitala w wybranym języku. Sprawdzaj aktualizacje online."
  },
  "ur": {
    "scanToOpenIn": "اس زبان میں کھولنے کے لیے اسکین کریں:",
    "qrDescription": "یہ کیو آر کوڈ ہسپتال کا موجودہ شائع شدہ نگہداشت کا رہنما منتخب زبان میں کھولتا ہے۔ تازہ ترین معلومات آن لائن دیکھیں۔"
  },
  "bn": {
    "scanToOpenIn": "এই ভাষায় খুলতে স্ক্যান করুন:",
    "qrDescription": "এই কিউআর কোডটি নির্বাচিত ভাষায় হাসপাতালের বর্তমানে প্রকাশিত চিকিৎসাপথের নির্দেশিকা খুলবে। অনলাইনে হালনাগাদ তথ্য দেখুন।"
  },
  "pa": {
    "scanToOpenIn": "ਇਸ ਭਾਸ਼ਾ ਵਿੱਚ ਖੋਲ੍ਹਣ ਲਈ ਸਕੈਨ ਕਰੋ:",
    "qrDescription": "ਇਹ QR ਕੋਡ ਹਸਪਤਾਲ ਦੀ ਇਸ ਵੇਲੇ ਪ੍ਰਕਾਸ਼ਿਤ ਦੇਖਭਾਲ ਯਾਤਰਾ ਨੂੰ ਚੁਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਖੋਲ੍ਹਦਾ ਹੈ। ਨਵੀਆਂ ਜਾਣਕਾਰੀਆਂ ਲਈ ਔਨਲਾਈਨ ਜਾਂਚ ਕਰੋ।"
  },
  "ro": {
    "scanToOpenIn": "Scanați pentru a deschide în limba",
    "qrDescription": "Acest cod QR deschide parcursul de îngrijire publicat în prezent de spital, în limba selectată. Verificați actualizările online."
  },
  "so": {
    "scanToOpenIn": "Iskaan garee si aad ugu furto afka",
    "qrDescription": "Koodhkan QR wuxuu ku furayaa hagaha daryeelka ee hadda isbitaalku daabacay luqadda aad dooratay. Ka hubi cusboonaysiinta internetka."
  },
  "pt": {
    "scanToOpenIn": "Leia o código para abrir em",
    "qrDescription": "Este código QR abre o percurso de cuidados atualmente publicado pelo hospital no idioma selecionado. Consulte as atualizações online."
  },
  "it": {
    "scanToOpenIn": "Scansioni per aprire in",
    "qrDescription": "Questo codice QR apre il percorso di cura attualmente pubblicato dall'ospedale nella lingua selezionata. Controlli gli aggiornamenti online."
  },
  "gu": {
    "scanToOpenIn": "આ ભાષામાં ખોલવા માટે સ્કેન કરો:",
    "qrDescription": "આ QR કોડ પસંદ કરેલી ભાષામાં હોસ્પિટલની હાલ પ્રકાશિત સંભાળ માર્ગદર્શિકા ખોલે છે. નવી માહિતી માટે ઑનલાઇન તપાસો."
  },
  "tr": {
    "scanToOpenIn": "Şu dilde açmak için tarayın:",
    "qrDescription": "Bu QR kodu, hastanenin güncel yayımlanmış bakım yolculuğunu seçilen uygulama dilinde açar. Güncellemeleri çevrimiçi kontrol edin."
  },
  "fa": {
    "scanToOpenIn": "برای باز کردن به این زبان اسکن کنید:",
    "qrDescription": "این کد QR راهنمای مسیر مراقبت منتشرشده فعلی بیمارستان را به زبان انتخاب‌شده باز می‌کند. به‌روزرسانی‌ها را به‌صورت آنلاین بررسی کنید."
  },
  "zh": {
    "scanToOpenIn": "扫码查看以下语言版本：",
    "qrDescription": "此二维码会以所选语言打开医院当前发布的就医流程指南。请在线查看最新信息。"
  },
  "tl": {
    "scanToOpenIn": "I-scan upang buksan sa wikang",
    "qrDescription": "Binubuksan ng QR code na ito ang kasalukuyang inilathalang gabay sa pangangalaga ng ospital sa napiling wika. Tingnan online ang mga bagong impormasyon."
  }
});
